<template>
  <div class="page-content">
    <!-- 页面标题区域 -->
    <div class="page-header d-flex d-flex-between d-flex-middle">
      <div class="page-title d-flex d-flex-middle">
        <span class="title-bar"></span>
        <span class="title-text">报名注册</span>
      </div>
    </div>

    <!-- 报名信息部分 -->
    <div class="section registration-info">
      <div class="d-flex d-flex-between d-flex-middle">
        <div class="section-title">
            <span class="title-text">报名信息</span>
        </div>
        <div class="header-buttons" v-if="studentInfo.status != '1'">
            <el-button class="modify-btn" @click="handleModifyInfo" v-if="studentInfo.type !=3 && !payStatus">修改信息</el-button>
            <el-button class="complete-btn" @click="handleCompleteInfo">完善信息</el-button>
        </div>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-item">
            <span class="label">姓名:</span>
            <span class="value">
              {{ studentInfo.name }}
              <span v-if="studentInfo.certiNo" class="ticket-number">
                (准考证{{ studentInfo.certiNo }})
              </span>
            </span>
          </div>
          <div class="info-item">
            <span class="label">性别:</span>
            <span class="value">{{ studentInfo.gender | f('sex') }}</span>
          </div>
          <div class="info-item">
            <span class="label">证件号:</span>
            <span class="value">{{ studentInfo.idCardNumber }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业:</span>
            <span class="value">{{ studentInfo.specialtyCode ? studentInfo.specialtyCode + '-' + studentInfo.specialtyName : studentInfo.specialtyName }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业层次:</span>
            <span class="value">{{ studentInfo.eduLevel | f('edulevel') }}</span>
          </div>
          <div class="info-item">
            <span class="label">助学点:</span>
            <span class="value">{{ studentInfo.orgCode ? studentInfo.orgCode + '-' + studentInfo.orgName : studentInfo.orgName }}</span>
          </div>
          <!-- <div class="info-item full-width">
            <span class="label">入学通知书:</span>
            <a v-if="noticeUrl" href="javascript:void(0)" class="download-link" @click="handleDownloadNotice">下载入学通知书</a>
            <span v-else class="value">暂无</span>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 缴费部分 -->
    <div class="section payment-section">
      <div class="section-title d-flex d-flex-middle d-flex-between">
        <span class="title-text">缴费</span>
      </div>
      <div class="section-content">
        <el-table
          :data="feeList"
          border
          style="width: 100%"
          :header-cell-style="{ background: '#E9EFF9', color: '#1a1a1a', fontWeight: '500' }"
        >
          <el-table-column width="60" align="center">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                :disabled="scope.row.status === 'YZF' || !canPayYear(scope.row)"
                @change="(val) => handleCheckboxChange(val, scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="yearTime" label="助学年份" align="center"></el-table-column>
          <el-table-column label="费用标准 (元/年)" align="center">
            <template slot-scope="scope">
              {{ Number(scope.row.money) == 0 ? '免费' : scope.row.money }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 'YZF'" class="YZF-text">{{ Number(scope.row.money) == 0 ? '' : '已缴' }}</span>
              <span v-else-if="!canPayYear(scope.row)" class="disabled-pay-text">未缴</span>
              <a v-else href="javascript:void(0)" class="pay-link" @click="handleGoToPay(scope.row)">缴费</a>
            </template>
          </el-table-column>
        </el-table>

        <!-- 合计金额 -->
        <div class="total-amount">
          <span class="total-label">合计:</span>
          <span class="total-value">{{ totalAmount }}元</span>
        </div>
      </div>
    </div>

    <!-- 底部缴费按钮 -->
    <div class="action-buttons d-flex d-flex-middle d-flex-center">
      <el-button class="pay-btn" @click="handlePay">缴费</el-button>
    </div>

    <!-- 支付弹窗 -->
    <PayDialog ref="payDialog" @refresh="handleRefresh" />
  </div>
</template>

<script>
import PayDialog from '@/components/bm/PayDialog.vue'

export default {
  name: 'BmRegister',
  components: {
    PayDialog
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      studentInfo: {},
      feeList: [],
      noticeUrl: '',
      payStatus: true
    }
  },
  computed: {
    totalAmount() {
      return this.feeList
        .filter(item => item.checked && item.status !== 'YZF')
        .reduce((sum, item) => sum + (item.money || 0), 0)
    }
  },
  created() {
    this.loadStudentInfo()
  },
  methods: {
    getYearNumber(yearTime) {
      if (yearTime === null || yearTime === undefined) return null
      const str = String(yearTime)
      const numberMatch = str.match(/\d+/)
      if (numberMatch) return Number(numberMatch[0])
      const chineseMap = { 一: 1, 二: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9 }
      const chineseMatch = str.match(/第([一二三四五六七八九])/)
      if (chineseMatch && chineseMap[chineseMatch[1]]) return chineseMap[chineseMatch[1]]
      return null
    },
    canPayYear(row) {
      const currentYear = this.getYearNumber(row.yearTime)
      if (!currentYear || currentYear <= 1) return true
      return this.feeList.every(item => {
        const y = this.getYearNumber(item.yearTime)
        if (y === null || y >= currentYear) return true
        return item.status === 'YZF'
      })
    },
    loadStudentInfo() {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
          this.studentInfo = res
          this.loadPaymentData()
          this.loadNoticeUrl()
        })
    },
    loadNoticeUrl() {
      if (!this.studentInfo.id) {
        this.noticeUrl = ''
        return
      }
      this.$http.get(this.MOCK_PREFIX + '/student/pc/getNoticeUrl?studentId=' + this.studentInfo.id).then(res => {
        this.noticeUrl = res || ''
      }).catch(() => {
        this.noticeUrl = ''
      })
    },
    loadPaymentData() {
      if (this.studentInfo.id) {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/getFee', { studentId: this.studentInfo.id }).then(res => {
          if (res && res.records) {
            this.feeList = res.records.map(item => ({
              ...item,
              checked: item.checked || false,
              status: Number(item.money) == 0 ? 'YZF' : item.status
            }))
            if(res.records.length == 0){
              this.payStatus = true
            }else{
              var isPayList = this.feeList.find(item => item.status == 'YZF');
              this.payStatus = isPayList ? true : false;
            }
          }
        })
      }
    },
    handleCheckboxChange(checked, row) {
      // 只允许选一个：当选中某个选项时，取消其他所有选项
      if (checked) {
        // 先取消所有其他选项
        this.feeList.forEach(item => {
          if (item !== row) {
            this.$set(item, 'checked', false)
          }
        })
        // 确保当前选项为选中状态
        this.$set(row, 'checked', true)
      }
    },
    handleGoToPay(row) {
      // 单个项目去缴费
      if (row.orderId) {
        // 如果已有订单，直接获取订单详情并打开支付弹窗
        this.$http.get(this.MOCK_PREFIX + '/student/pc/studyFee/order/getDetail/' + row.orderId).then(res => {
          this.$refs.payDialog.open(res)
        })
      } else {
        // 创建新订单
        if (!this.studentInfo.id) {
          this.$message.warning('学生信息不完整，无法创建订单')
          return
        }
        this.$http.post(this.MOCK_PREFIX + '/student/pc/studyFee/order/create/' + row.yearTime, {
          studentId: this.studentInfo.id
        }).then(res => {
          this.$refs.payDialog.open(res)
        })
      }
    },
    handleDownloadNotice() {
      if (this.noticeUrl) {
        window.open(this.noticeUrl, '_blank')
      } else {
        this.$message.warning('入学通知书暂不可用')
      }
    },
    handlePay() {
      // 缴费
      const selectedItems = this.feeList.filter(item => item.checked && item.status !== 'YZF')
      if (selectedItems.length === 0) {
        this.$message.warning('请选择要缴费的项目')
        return
      }

      const selectedItem = selectedItems[0]

      if (selectedItem.orderId) {
        // 如果已有订单，直接获取订单详情并打开支付弹窗
        this.$http.get(this.MOCK_PREFIX + '/student/pc/studyFee/order/getDetail/' + selectedItem.orderId).then(res => {
          this.$refs.payDialog.open(res)
        }).catch(err => {
          this.$message.error('获取订单详情失败，请稍后重试')
          console.error('获取订单详情失败:', err)
        })
      } else {
        // 创建新订单
        if (!this.studentInfo.id) {
          this.$message.warning('学生信息不完整，无法创建订单')
          return
        }
        this.$http.post(this.MOCK_PREFIX + '/student/pc/studyFee/order/create/' + selectedItem.yearTime, {
          studentId: this.studentInfo.id
        }).then(res => {
          this.$refs.payDialog.open(res)
        }).catch(err => {
          this.$message.error('创建订单失败，请稍后重试')
          console.error('创建订单失败:', err)
        })
      }
    },
    handleRefresh() {
      // 支付成功后刷新数据
      this.loadStudentInfo()
      this.loadPaymentData()
      this.$message.success('支付成功')
    },
    handleModifyInfo() {
      this.$router.push({ name: 'mineBmSelectLocation' })
    },
    handleCompleteInfo() {
      // 完善信息
      this.$router.push({ name: 'bmInfo' })
    },
    goToInvoice() {
      this.$router.push({ name: 'invoice' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  padding: 0 30px;
  min-height: 500px;
}

.page-header {
  height: 80px;
  line-height: 80px;
  padding: 0;
  border-bottom: none;

  .page-title {
    padding: 0;
    .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0 !important;
        margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
}
.header-buttons {
    display: flex;
    gap: 10px;

    .modify-btn,
    .complete-btn {
        border-radius: 16px;
        font-size: 14px;
        width: 90px;
        height: 32px;
        line-height: 1;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border: none;
        color: #fff;
        padding: 0;
        &:hover {
            background: #40a9ff;
        }
    }
  }

.section {
    box-sizing: border-box;
    padding: 30px 0;
    border-top: 1px solid #E9EFF9;

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }

  .section-content {
    background: #fff;
    padding-bottom: 0 !important;
  }
}

.registration-info {
  .section-content {
    padding: 20px 0;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px 50px;
    padding: 0 20px;

    .info-item {
      display: flex;
      align-items: flex-start;
      font-size: 14px;
      line-height: 1.6;

      &.full-width {
        grid-column: 1 / -1;
      }

      .label {
        color: #767676;
        margin-right: 10px;
        flex-shrink: 0;
        font-weight: 400;
      }

      .value {
        color: #303133;
        flex: 1;
        word-break: break-all;
        font-weight: 400;

        .ticket-number {
          color: #aaa;
          margin-left: 5px;
        }
      }
    }
  }

  .download-link {
    color: #1890ff;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #40a9ff;
      text-decoration: underline;
    }
  }
}

.payment-section {
  .section-content {
    padding: 20px 0;
  }

  .invoice-link {
    color: #1890ff;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #40a9ff;
      text-decoration: underline;
    }
  }
}

// Element UI 表格样式覆盖
::v-deep .el-table {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  border: 1px solid #CAD6E1;
  border-right: 1px solid #CAD6E1 !important;

  .el-table__cell {
    border-bottom: 1px solid #CAD6E1 !important;
    border-right: 1px solid #CAD6E1 !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
      th {
        border-color: #CAD6E1;
        border-right: 1px solid #CAD6E1 !important;
        padding: 8px 0;
        background: #F5F7FA;

        &:last-child {
          border-right: 1px solid #CAD6E1 !important;
        }
      }
    }
  }

  .el-table__body-wrapper {
    border-right: 1px solid #CAD6E1 !important;

    .el-table__body {
      td {
        background-color: #fff;
        padding: 5px 0;
        border-right: 1px solid #CAD6E1 !important;

        &:last-child {
          border-right: 1px solid #CAD6E1 !important;
        }
      }
    }
  }

  .el-table__row {
    &:hover {
      background-color: #fff;
    }
  }
}

.YZF-text {
  color: #1a1a1a;
  font-size: 14px;
}

.disabled-pay-text {
  color: #c0c4cc;
  font-size: 14px;
}

.pay-link {
  color: #1890ff;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}

.total-amount {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #EA0000;
  border: 1px solid #CAD6E1;
  border-top: none;
  height: 40px;
  padding: 0 20px;

  .total-label {
    margin-right: 10px;
  }
}

.action-buttons {
  gap: 20px;
  padding-top: 30px;
  padding-bottom: 30px;

  .pay-btn {
    width: 120px;
    height: 36px;
    line-height: 1;
    padding: 0;
    background: #FF8F1F;
    border-radius: 18px;
    border: none;
    color: #fff;
    font-size: 14px;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
